function checkConsentmoState(adittionalChecks = 0) {
console.log('run!2');
  if (typeof window.Shopify !== 'undefined' && typeof window.Shopify.customerPrivacy !== 'undefined' && typeof window.Shopify.customerPrivacy.setTrackingConsent !== 'undefined' && typeof window.Shopify.customerPrivacy.setTrackingConsent === 'function') {
    let ccsCookie = (document.cookie.match(/^(?:.*;)?\s*cookieconsent_status\s*=\s*([^;]+)(?:.*)?$/)||[,null])[1];
    if(ccsCookie === null) {
      console.log('run!');
      window.Shopify.customerPrivacy.setTrackingConsent({"analytics": false, "marketing": false, "preferences": false}, () => {});
    }
  } else {
    if (adittionalChecks > 0) {
      setTimeout(function() {
        checkConsentmoState(adittionalChecks - 1);
      }, 500);
    }
  }
}
checkConsentmoState(20);